import {
  TestAttributePhaseEnum,
  type TestTemplateAttribute,
} from "@brewbase/db/types";
import { LockIcon } from "lucide-react";
import type { BaseTemplateAttribute } from "@/features/template-block-editor/types";

const PHASE_LABEL: Record<string, string> = {
  PREP: "Prep",
  MEASURE: "Measure",
  RESULT: "Result",
  REVIEW: "Review",
};

/** Generated by the template's blueprint (a method's fields). */
export function isGeneratedAttribute(attr: BaseTemplateAttribute): boolean {
  return (attr as TestTemplateAttribute).managed_key != null;
}

function GeneratedBadge() {
  return (
    <LockIcon
      className="size-3 shrink-0 text-olive-9"
      aria-label="Generated"
    >
      <title>Generated by the method&apos;s blueprint; changes with its compounds</title>
    </LockIcon>
  );
}

/** Right-hand flags cell of a scalar row (test editor). */
export function renderTestRowFlags(attr: BaseTemplateAttribute) {
  const attribute = attr as TestTemplateAttribute;
  const isResult = attribute.phase === TestAttributePhaseEnum.RESULT;
  return (
    <>
      {isGeneratedAttribute(attr) && <GeneratedBadge />}
      {attribute.code && (
        <span
          className="text-xs font-mono text-olive-9 truncate max-w-[80px]"
          title={attribute.code}
        >
          {attribute.code}
        </span>
      )}
      {attribute.phase && (
        <span
          className={`border px-1 py-0.5 text-xs font-sans ${
            isResult
              ? "border-farmless-green-8 text-farmless-green-8"
              : "border-border"
          }`}
        >
          {PHASE_LABEL[attribute.phase]}
        </span>
      )}
      {attribute.is_specification && (
        <span className="border border-border px-1 py-0.5 text-xs font-sans">
          Spec
        </span>
      )}
    </>
  );
}

/** Tabular block header badge (test editor). */
export function renderTestTabularBadge(attr: BaseTemplateAttribute) {
  const attribute = attr as TestTemplateAttribute;
  return (
    <>
      {isGeneratedAttribute(attr) && <GeneratedBadge />}
      {attribute.is_specification && (
        <span className="border border-border px-1 py-0.5 text-xs">Spec</span>
      )}
    </>
  );
}
